import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {TreatmentJourneyDataService} from "./impl/service/ngrx/treatmentJourneyData.service";
import {TreatmentJourneyRepository} from "./impl/service/ngrx/treatmentJourney.repository";


@NgModule()
export class TreatmentJourneyCommonModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: TreatmentJourneyDataService,
                service: TreatmentJourneyRepository,
    ) {

        entityDataService.registerServices({
            TreatmentJourney: dataService,
        });

        entityServices.registerEntityCollectionServices({
            TreatmentJourney: service,
        });
    }
}
